/* eslint-disable no-console */
import { getUserFromCookie } from '@/helpers'

export const actions = {
  async nuxtServerInit(
    { dispatch, getters },
    { req, params, query, route, redirect, error }
  ) {
    try {
      const user = getUserFromCookie(req)
      if (user) {
        await dispatch('user/setUser', {
          displayName: user.name,
          email: user.email || 'anonymous@pedalsure.com',
          avatar: user.picture,
          uid: user.user_id,
        })
      }
    } catch (userError) {
      console.log(
        'Error getting user from cookie in nuxtServerInit:',
        userError.message
      )
    }

    if (query) {
      if (query.discount) {
        // dispatch action to get discount from url code
        try {
          await dispatch('quote/getCodeDiscount', query.discount)
        } catch (e) {
          console.log('Error getCodeDiscount', e)
          console.log('Fallback to default discount')
          await dispatch('quote/getDefaultDiscount')
        }
      } else if (query.discountPartner) {
        // dispatch action to get discount from partner Slug
        try {
          await dispatch('quote/getPartnerDiscount', query.discountPartner)
        } catch (e) {
          console.log('Error getPartnerDiscount', e)
          console.log('Fallback to default discount')
          await dispatch('quote/getDefaultDiscount')
        }
      } else {
        // dispatch action to get default discount
        try {
          await dispatch('quote/getDefaultDiscount')
        } catch (e) {
          console.log('index store init discount', e)
        }
      }
    }

    if (query.type === 'mta' || query.type === 'payment') {
      return redirect(`/dashboard/policy/${params.quoteid}`)
    }
  },
}
